import React from 'react'
import Hero from '../components/Hero';
import CampDetails from '../components/CampDetails.js'
import Footer from '../components/Footer';
import Pricing from '../components/Pricing';
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import PromoVideo from '../components/PromoVideo';
// import { ScrollRestoration } from 'react-router-dom';
import SuccessMessage from '../components/SuccessMessage';
function Home() {
  window.scrollTo(0,0)
  return (
    <div className="p-0 relative" style={{overflowAnchor: 'none'}}>
      
      <Navbar/>
      <SuccessMessage/>
      <Hero/>
      <PromoVideo/>
      <CampDetails/>
      <Carousel/>
      
      <Pricing/> 
      
      <Footer/>
      
    </div>
  )
}

export default Home